<template>
  <div class="charttest">
    <div   style="width: 100%;
    height: 294px;padding-bottom: 50px;" :id="echarts" ref="echarts">
    </div>
  </div>
</template>
<script>
  import echarts from 'echarts'
  import { mapActions } from "vuex";

  export default {
    name:'LineChart',
    data() {
      return {
      resultList: [
        {
          value: "",
          name: "",
        },
      ],
      };
    },
      created() {
        this.initChartsChart()
      },

    methods: {
         ...mapActions("category", [
        "getChartData",
    ]),
    initChartsChart() {
  let _this = this;
      let data = {
        params: {
          gid: 1,
          chartTplCode: "pa_type_detail",
        },
      };
      this.getChartData({
        data: data,
        handle(res) {
          let list = res.message;
          _this.paTypeValid = res.message.data;
          console.log(_this.paTypeValid, "===_this.paTypeValid====");
          const result = _this.paTypeValid.reduce((cur, next) => {
            if (Object.keys(cur).length > 0) {
              Object.keys(cur).map((item, index) => {
                cur[item] += next.data[item];
              });
            } else {
              cur = next.data;
            }
            return cur;
          }, {});
          _this.resultList = Object.entries(result).map(([key, value]) => ({
            name: key,
            value: value,
          }));
          console.log(_this.resultList, "== _this.resultList====");
        },
      });

    },


 initChart() {
      this.myChart = echarts.init(this.$refs.echarts);
      window.addEventListener("resize", () => {
        this.myChart.resize();
      });
    },
      drawCharts() {
        var myChart = echarts.init(document.getElementById(this.echarts));
        myChart.setOption({
         color: ["#7FCAFF", "#67E0C7", "#FFCF6D", "#33D1B1", "#29A6FF"],
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c}",
        },
        grid: {
          right: "60",
          left: "40",
          top: "20",
          containLabel: true,
        },

        series: [
          {
            name: "",
            type: "pie",
            radius: "70%",
            avoidLabelOverlap: true,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "12",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            //专利类型
            data: this.resultList,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  formatter: "{b} : {c}",
                  fontSize: 12,
                  borderWidth: 20,
                  borderRadius: 4,
                },
                labelLine: { show: true, length: 10, length2: 20 },
              },
            },
          },
        ],
        });

      }
      
    },
    computed: {
      echarts() {
        return 'echarts' + Math.random() * 100000;
      }
    },
    mounted() {
    //   this.drawCharts();
      this.$nextTick(() => {
      setTimeout(() => {
        this.drawCharts();
      
      },1000);
    });
    },
     destroyed() {
    window.removeEventListener("resize", this.initChart, 20);
  },
    components: {}
  };
</script>

<style></style>